module.exports = __webpack_public_path__ + "static/media/brdid-logo.a8b1ebc0.png";